export default {
  GET_ALL_PHASE: "GET_ALL_PHASE",
  SAVE_PHASE: "SAVE_PHASE",
};
